/** The audio calls a cave makes (the game's `GameAudio` has these and more). */

import type { SimEvent } from '../../sim/types';

export interface RunAudio {
  events(events: readonly SimEvent[], listenerX: number): void;
  ambience(a: { amoeba: boolean; magic: boolean; cover: boolean }): void;
  cue(c: 'bonusLife' | 'bonusTick' | 'pause' | 'resume' | 'start', n?: number): void;
}

/** For the demo and tests: silence. */
export const SILENT: RunAudio = {
  events: () => undefined,
  ambience: () => undefined,
  cue: () => undefined,
};
